import {Box} from "@mui/material";
import React from "react";

export default function HighlightCard({summary}){
    return(
        <Box sx={styles.card}>
            <Box as={'p'} sx={styles.highlight}>
                Highlights
            </Box>
            <Box sx={styles.summary} as={'p'}>
                {summary}
            </Box>
        </Box>
    )
}

export const styles = {
    card: {
        width: "100%",
        padding: "25px",
        background: "#FFFFFF",
        borderRadius: "8px",
        border: "1px solid #dee2e0",
        boxShadow: "0 2px 4px 0 rgba(196, 201, 199, 0.5)",
    },
    summary: {
        fontFamily: "FustatMedium",
        fontSize: "14px",
        fontWeight: 500,
        color: "#302E2A",
        margin: "0"
    },
    highlight: {
        fontFamily: "FustatBold",
        fontSize: "15px",
        color: "#302E2A",
        margin: "0"
    },
}